
window._ = require('lodash');

window.$ = require('jquery');

// window.swal = require('sweetalert2');


window.swal = require('sweetalert2')
require('fitvids')()
window.stripe = Stripe(window.wp_slickfish_api.stripe_key)
window.elements = stripe.elements()

window.queryString = require('query-string')

require('jquery-parallax.js')

window.Vue = require('vue');
window.Vue.component('programs-and-events', require('./ProgramsAndEvents.vue') );
window.Vue.component('program-checkout', require('./ProgramCheckout.vue') );
// Vue.use(require('vee-validate'), {fieldsBagName: 'formFields'});

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
var ES6Promise = require("es6-promise");
ES6Promise.polyfill();

window.axios = require('axios');

window.axios.defaults.headers.common = {
    'X-WP-Nonce': window.wp_slickfish_api.nonce,
    'X-Requested-With': 'XMLHttpRequest'
};
window.axios.defaults.baseURL = window.wp_slickfish_api.root

new window.Vue({
  el: '#app'
})



// WEBPACK FOOTER //
// ./assets/js/bootstrap.js